<template>
    <div class="city-selector-inline">
        <a-select
            mode="multiple"
            v-model="selectedCities"
            style="width: 100%"
            :filter-option="false"
            @search="getCitiesBySearch"
            @change="() => getCitiesBySearch()"
            :not-found-content="fetching ? undefined : null"
        >
            <a-spin v-if="fetching" slot="notFoundContent" size="small" />
            <a-select-option v-for="item of items" :key="item.key" :value="item.key">
                {{ item.value }}
            </a-select-option>
        </a-select>
    </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
    name: "CitySelectorInline",
    props: {
        value: {
            type: Array,
            default: () => [],
        },
    },
    data: () => ({
        fetching: false,
        selectedCities: [],
        items: [],
        searchTimeout: null,
    }),
    mounted() {
        if (Array.isArray(this.value)) this.selectedCities = this.value;
        this.getCitiesBySearch();
    },
    methods: {
        ...mapActions({
            getContactByField: "visitor/getContactByField",
        }),
        getCitiesBySearch(query) {
            if (this.searchTimeout) clearTimeout(this.searchTimeout);
            this.searchTimeout = setTimeout(() => {
                this.fetching = true;
                this.getContactByField({ field: "city", query }).then((items) => {
                    this.items = this.$_.uniq(items).map((item) => ({
                        key: item,
                        value: item,
                    }));
                    this.fetching = false;
                });
            }, 500);
        },
    },
    watch: {
        selectedCities() {
            this.$emit("input", this.selectedCities);
        },
        value() {
            this.selectedCities = this.value;
        },
    },
};
</script>
